import theme from '../../common/theme';

const styles = {
    EmailSettingsContainer : {
        backgroundColor : theme.primary_background_dark
    }
};

export default styles;